import clsx from 'clsx'

import { Post } from '@tribeplatform/gql-client/types'
import { HtmlContent } from '@tribeplatform/react-components/HtmlContent'

import { StaticField } from '../../Views/types'

interface Props {
  field: StaticField
  post: Post
  highlighted: boolean
  stretchX: string
  lineClamp?: 'none' | 'sm' | 'md' | 'lg'
  preview: boolean
}

export const GalleryPostContent = ({
  field,
  post,
  highlighted,
  stretchX,
  lineClamp = 'none',
  preview,
}: Props) => {
  const { default: defaultContent } = field
  const content = post?.shortContent || (preview ? defaultContent : '')

  return (
    <div
      className={clsx(
        'empty:hidden min-w-0',
        highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        stretchX,
      )}
    >
      <article
        className={clsx(
          'break-words',
          lineClamp === 'sm' && 'line-clamp-2',
          lineClamp === 'md' && 'line-clamp-3',
          lineClamp === 'lg' && 'line-clamp-5',
        )}
      >
        <HtmlContent
          value={content}
          attachments={post?.attachments}
          embeds={post?.embeds}
          mentions={post?.mentions}
        />
      </article>
    </div>
  )
}
